import isArrayLikeObject from "lodash/isArrayLikeObject";
import isObjectLike from "lodash/isObjectLike";
import isNil from "lodash/isNil";
import mapValues from "lodash/mapValues";
import omitBy from "lodash/omitBy";

export function deepOmitNullish(o: object): unknown {
  if (isArrayLikeObject(o)) {
    return (o as object[]).filter(v => !isNil(v)).map(deepOmitNullish);
  }
  if (isObjectLike(o)) {
    return omitBy(mapValues(o, deepOmitNullish), isNil);
  }
  return o;
}
